import axios from 'axios';
import { LOCAL_STORAGE } from '../constants/constants';

export const axiosInstance = axios.create({
    baseURL: '/goodsin-admin/api/v1',
    timeout: 30000,
    headers: { 'Content-Type': 'application/json' },
});

axiosInstance.interceptors.request.use(config => {
    const token = localStorage.getItem(LOCAL_STORAGE.JJ_INTERNAL);
    if (token) {
        config.headers['X-JJ-Token'] = token;
    }
    return config;
});

axiosInstance.interceptors.response.use(
    response => response,
    error => {
        if (error.code === 'ECONNABORTED') {
            console.error('Request timeout');
        }
        if (error?.response?.data?.Error === 'TOKEN_EXPIRED') {
            console.error('Token expired');
        }
        return Promise.reject(error);
    }
);